import PageTransition from "./PageTransition";
require("./transition-dash.less");

export default class PageTransitionDash extends PageTransition{
    constructor(svg){
        super();
        /**
         *
         * @type {JQuery}
         */
        this.$main=$(require("./transition-dash.html"));
        $body.append(this.$main);
        this.$text=this.$main.find(".text");
        /*
        this.hidePage();
        let me=this;
        setTimeout(function(){
            me.showPage();
        },1000);
        */

    }

    randText(){
        var item = LayoutVars.transiTexts[Math.floor(Math.random()*LayoutVars.transiTexts.length)];
        this.$text.text(String(item))
    }

    hidePage(cb,transitionDuration=0.5){
        let me=this;
        me.$main.addClass("hide");
        this.startloop();
        window.$body.addClass("is-transition");
        window.FK.setNavColor("black","fk");
        setTimeout(function () {
            if(cb){
                cb();
            }
        },1000);

    }
    showPage(cb){
        let me=this;
        window.$body.removeClass("is-transition");
        this.stoploop(0,pov.history.currentPageInfo.name);
        setTimeout(function () {
            me.$main.removeClass("hide");
        },500);
        setTimeout(function () {
            if(cb){
                cb();
            }
        },1000);

    }

    startloop(){
        if(this.loop) {
            clearInterval(this.loop);
        }
        let me=this;
        this.loop=setInterval(function(){
            me.randText();
        },150)

    }
    stoploop(delay=0,text=""){
        let me=this;
        setTimeout(function(){
            if(me.loop) {
                clearInterval(me.loop);
            }
        },delay)
        if(text){
            me.$text.text(String(text))
        }

    }

}


// WEBPACK FOOTER //
// ./fk.app/_src/transitions/PageTransitionDash.js